import type { Section } from '../../../../../api/types/expenseareas';

export type BuilderPublishResult =
    | { ok: true }
    | { ok: false; reason: 'no-sections' }
    | { ok: false; reason: 'invalid'; sectionErrors: string[]; fieldsErrors: string[] };

export const isFieldIdInErrors = (fieldId: string | number | null | undefined, fieldsError: string[]) =>
    fieldId != null && fieldsError.some((e) => String(e) === String(fieldId));

export const escapeAttrSelector = (val: string) =>
    typeof CSS !== 'undefined' && typeof CSS.escape === 'function' ? CSS.escape(val) : val.replace(/\\/g, '\\\\');

export const scrollIntoFormColumnSmooth = (container: HTMLElement, el: HTMLElement | null, offset = 20) => {
    if (!el) return;
    const nextTop =
        container.scrollTop + (el.getBoundingClientRect().top - container.getBoundingClientRect().top) - offset;
    container.scrollTo({ top: Math.max(0, nextTop), behavior: 'smooth' });
};

/** Порядок секций как в `sections` (для Kick-off можно передать только видимые секции). */
export const getFirstBuilderValidationErrorElement = (
    container: HTMLElement,
    sections: Section[] | undefined,
    sectionErrors: string[],
    fieldsErrors: string[]
): HTMLElement | null => {
    if (!sections?.length) return null;
    const secSet = new Set(sectionErrors.map(String));
    const fieldSet = new Set(fieldsErrors.map(String));

    for (const section of sections) {
        if (secSet.has(String(section.localId))) {
            const el = container.querySelector(`[data-builder-section="${escapeAttrSelector(String(section.localId))}"]`);
            if (el) return el as HTMLElement;
        }
        for (const field of section.fields || []) {
            if (fieldSet.has(String(field.id))) {
                const el = container.querySelector(
                    `[data-builder-field-id="${escapeAttrSelector(String(field.id))}"]`
                );
                if (el) return el as HTMLElement;
            }
        }
    }
    return null;
};
